import React from "react";
import "./AnalyticBox.scss";
import {
  StarFilled,
  ArrowUpOutlined,
  ArrowDownOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { Divider } from "antd";
import { useUnit } from "contexts/UnitContext";

interface IAnalyticBox {
  id: number;
  title: string;
  value: any;
  isIncrease?: boolean;
  percent?: string;
  selected: any;
  setSelected: (selected: any) => void;
  hayValue?: string;
  seedValue?: string;
  strawValue?: string;
}

const AnalyticBox: React.FC<IAnalyticBox> = ({
  id,
  title,
  value,
  isIncrease,
  percent,
  selected,
  setSelected,
  hayValue,
  seedValue,
  strawValue,
}) => {
  const { units } = useUnit();
  value = title == "Income" ? "$" + value : value;
  return (
    <div
      className={`AnalyticBox ${selected ? "selected" : ""}`}
      onClick={() => setSelected(id)}
      key={id}
    >
      <div className="title">{title}</div>
      <div className="value">
        {value}
        {title == "Overall Rating" ? (
          <StarFilled style={{ color: "#f9a72e" }} />
        ) : (
          ""
        )}
      </div>
      {title == "All Products" ? (
        <div className="categories">
          <div className="category-item">
            <div className="value">{hayValue}</div>
            <div className="name">Hay</div>
          </div>
          <Divider type="vertical" className="cate-divider" />
          <div className="category-item">
            <div className="value">{strawValue}</div>
            <div className="name">Straw</div>
          </div>
          <Divider type="vertical" className="cate-divider" />
          <div className="category-item">
            <div className="value">{seedValue}</div>
            <div className="name">Seed</div>
          </div>
        </div>
      ) : (
        <>
          <div className={`growth-rate ${isIncrease ? "increase" : ""}`}>
            <div className="percent">
              {isIncrease ? <ArrowUpOutlined /> : <ArrowDownOutlined />}{" "}
              {percent}
            </div>
          </div>
          <div className="in-time">
            During 1 month <InfoCircleOutlined />
          </div>
        </>
      )}
    </div>
  );
};

export default AnalyticBox;
